import { ArchetypeDefinition } from '../../archetypeTypes';

export const HUMOR_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'jester',
        name: 'Jester',
        description: 'Playful disruption and reframe through surprising patterns.',
        category: 'Humor',
        tags: ['play', 'reframe', 'surprise'],
        weights: { waveIntensity: 0.35, linguisticComplexity: 0.25, edgeCount: 0.25, stability: 0.15 }
    }
];


